import React, { useState } from 'react';
import api from '../../../utils/api';

const productManufacturer = (product) => {
    const manufacturer = product?.manufacturer;
    if (Array.isArray(manufacturer)) return manufacturer[0]?.name || '';
    return manufacturer?.name || manufacturer || '';
};

const PopularProductSelector = ({ products = [], onChange }) => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);

    const searchProducts = async (value) => {
        setQuery(value);

        if (!value.trim()) {
            setResults([]);
            return;
        }

        setIsSearching(true);
        try {
            const response = await api.smartSearch(`?query=${encodeURIComponent(value.trim())}`);
            const allResults = response.data?.data?.results || [];
            setResults(allResults.filter((item) => item?.type === 'product'));
        } catch (error) {
            console.error(error);
            setResults([]);
        } finally {
            setIsSearching(false);
        }
    };

    const addProduct = (product) => {
        if (products.some((item) => item?._id === product?._id)) return;
        onChange([...products, product]);
        setQuery('');
        setResults([]);
    };

    const removeProduct = (productId) => {
        onChange(products.filter((item) => item?._id !== productId));
    };

    return (
        <div>
            <input
                type="search"
                value={query}
                placeholder="Search all products by part number or name"
                onChange={(event) => searchProducts(event.target.value)}
                style={{ width: '100%', border: '1px solid #cbd5e1', borderRadius: 6, padding: '12px 14px', fontSize: 14 }}
                aria-label="Search all products"
            />

            {query && (
                <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 6, marginTop: 6, maxHeight: 230, overflowY: 'auto' }}>
                    {isSearching ? (
                        <p style={{ margin: 0, padding: 12, color: '#64748b' }}>Searching products…</p>
                    ) : results.length ? results.map((product) => (
                        <button
                            type="button"
                            key={product?._id}
                            onClick={() => addProduct(product)}
                            style={{ display: 'block', width: '100%', padding: 12, textAlign: 'left', border: 0, borderBottom: '1px solid #f1f5f9', background: '#fff', cursor: 'pointer' }}
                        >
                            <strong>{product?.name || 'Unnamed product'}</strong>
                            {productManufacturer(product) && <span style={{ display: 'block', marginTop: 3, color: '#64748b', fontSize: 12 }}>{productManufacturer(product)}</span>}
                        </button>
                    )) : (
                        <p style={{ margin: 0, padding: 12, color: '#64748b' }}>No products found.</p>
                    )}
                </div>
            )}

            <div style={{ marginTop: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <strong style={{ fontSize: 14 }}>Selected products ({products.length})</strong>
                    {products.length > 0 && (
                        <button type="button" onClick={() => onChange([])} style={{ border: 0, background: 'transparent', color: '#c2410c', cursor: 'pointer' }}>
                            Remove all
                        </button>
                    )}
                </div>
                {products.length ? (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 10 }}>
                        {products.map((product) => (
                            <div key={product?._id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: 10, border: '1px solid #e2e8f0', borderRadius: 6, background: '#fff' }}>
                                <img src={product?.image} alt="" style={{ width: 44, height: 44, objectFit: 'contain', background: '#f8fafc' }} />
                                <div style={{ minWidth: 0, flex: 1 }}>
                                    <strong style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 13 }}>{product?.name || 'Unnamed product'}</strong>
                                    <span style={{ color: '#64748b', fontSize: 12 }}>{productManufacturer(product)}</span>
                                </div>
                                <button type="button" onClick={() => removeProduct(product?._id)} style={{ border: '1px solid #fecaca', borderRadius: 4, background: '#fff', color: '#dc2626', padding: '6px 8px', cursor: 'pointer' }}>
                                    Remove
                                </button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p style={{ margin: 0, color: '#64748b', fontSize: 13 }}>No products selected yet.</p>
                )}
            </div>
        </div>
    );
};

export default PopularProductSelector;
